import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newLineReplace',
  standalone: false,
})
export class NewLineReplacePipe implements PipeTransform {
  constructor() {}

  public transform(value: string): string {
    if (!value) {
      return value;
    }
    return value.replace(/\n/g, '<br />');
  }
}
